export default __webpack_public_path__ + "static/media/guiaWindows4.533bdc51.png";